<script lang="ts">
	import { page } from '$app/state';
	import Header from '$lib/layout/header.svelte';
	import Newsletter from '$lib/newsletter/newsletter.svelte';
	import Footer from '$lib/storyblok/pages/footer.svelte';

	let { children } = $props();

	// temporary hack until we have the "universal" header
	let labLp = $derived(
		page.route.id === '/(marketing)/lab/[...slug]' &&
			(page.data.story?.full_slug?.startsWith('lp/') ||
				page.data.story?.full_slug?.startsWith('food-recycler'))
	);

	let showNewsletter = $derived(
		!page.route.id ||
			(!page.route.id.startsWith('/(marketing)/order-now') &&
				!['/(marketing)', '/(marketing)/food-recycler', '/(marketing)/reviews'].includes(
					page.route.id
				))
	);
	let showHeader = $derived(
		!page.route.id?.startsWith('/(marketing)/order-now') &&
			page.route.id !== '/(marketing)' &&
			page.route.id !== '/(marketing)/food-recycler' &&
			!labLp
	);
	let showFooter = $derived(!page.route.id || !page.route.id.startsWith('/(marketing)/order-now'));
</script>

{@render children?.()}

{#if showHeader}
	<Header />
{/if}

{#if showNewsletter}
	<Newsletter />
{/if}

{#if showFooter}
	<Footer />
{/if}
